import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private keycloakService: KeycloakService) {}

  /**
   * Prüft, ob der Benutzer eingeloggt ist
   */
  isLoggedIn(): boolean {
    return this.keycloakService.isLoggedIn();
  }

  /**
   * Prüft, ob der Benutzer die Admin-Rolle hat
   */
  hasAdminRole(): boolean {
    return this.keycloakService.isUserInRole('admin');
  }

  /**
   * Gibt den Benutzernamen zurück
   */
  getUsername(): string | undefined {
    try {
      if (!this.keycloakService.isLoggedIn()) {
        console.warn('[AuthService] User is not logged in');
        return undefined;
      }

      // Versuche zuerst den Username zu holen
      const username = this.keycloakService.getUsername();
      if (username) {
        return username;
      }

      // Fallback: Versuche aus dem Token zu lesen
      const tokenParsed = this.keycloakService.getKeycloakInstance()?.tokenParsed as any;
      if (tokenParsed?.preferred_username) {
        console.log('[AuthService] Using preferred_username from token:', tokenParsed.preferred_username);
        return tokenParsed.preferred_username;
      }

      if (tokenParsed?.email) {
        console.log('[AuthService] Using email from token:', tokenParsed.email);
        return tokenParsed.email;
      }

      console.warn('[AuthService] Could not extract username from token');
      return undefined;
    } catch (error) {
      console.error('[AuthService] Error getting username:', error);
      return undefined;
    }
  }

  /**
   * Startet den Login-Flow
   */
  login(): void {
    this.keycloakService.login({
      redirectUri: window.location.origin + '/admin'
    });
  }

  /**
   * Startet den Logout-Flow
   */
  logout(): void {
    this.keycloakService.logout(window.location.origin);
  }

  /**
   * Gibt das Access Token zurück
   */
  getToken(): Observable<string> {
    return from(this.keycloakService.getToken());
  }

  /**
   * Aktualisiert das Token
   */
  updateToken(minValidity: number = 30): Observable<boolean> {
    return from(this.keycloakService.updateToken(minValidity));
  }
}
